module.exports = __webpack_public_path__ + "media/images/ww1-ac309398e6a69dd7ad509c4f8ec9cb31.svg";